
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/transportbil/campervan",
      function () {
        return require("private-next-pages/rims/transportbil/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/transportbil/campervan"])
      });
    }
  